import { IspDashboard } from '../components/Dashboards/IspDashboard';

export const MainDashboard = () => {
  return <IspDashboard />
};
